import clsx from 'clsx';
import styles from '@danske/sapphire-css/components/modalLayout/modalLayout.module.css';
import {
  SapphireStyleProps,
  useSapphireStyleProps,
  useThemeCheck,
} from '../../utils';
import React, { ForwardedRef } from 'react';
import { DOMProps } from '@react-types/shared';
import { GlobalDomAttributes } from '../../utils/types';

export interface ModalLayoutFooterProps
  extends DOMProps,
    GlobalDomAttributes,
    Pick<SapphireStyleProps, 'UNSAFE_style' | 'UNSAFE_className'> {
  children?: React.ReactNode;
}

/**
 * Used in {@link ModalLayoutProps#footer footer} part of {@link ModalLayout}.
 * Ensures consistent padding with body and header parts.
 */
export const ModalLayoutFooter = React.forwardRef(function ModalLayoutFooter(
  props: ModalLayoutFooterProps,
  forwardedRef: ForwardedRef<HTMLDivElement>
): JSX.Element {
  useThemeCheck();
  const { styleProps } = useSapphireStyleProps(props);

  return (
    <div
      ref={forwardedRef}
      className={clsx(
        styles[`sapphire-modal-layout__footer`],
        styleProps.className
      )}
      style={styleProps.style}
      {...props}
    />
  );
});
